import ImageZoom from 'js-image-zoom/js-image-zoom'
export default class Imagezoom {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.url = ''
    this.cachedUrl = ''
    this.imageZoom = ''
  }

  init() {
    this.el.addEventListener('mouseover', this.handleOver)
  }

  handleOver(e) {
    const target = e.currentTarget
    const image = target.querySelector('img')
    this.url = image.src
    const zoom = target.querySelector('.image-zoom')
    // only create a new instance if the image changed
    if (this.url !== this.cachedUrl) {
      if (this.imageZoom) {
        this.imageZoom.kill()
      }
      // we're letting ImageZoom create its own instance of the image if hover
      // set ours to absolute, behind it
      image.classList.add('absolute')
      this.imageZoom = new ImageZoom(zoom, {
        img: this.url,
        scale: '1.0',
        offset: { vertical: 0, horizontal: 10 },
      })
    }
    this.cachedUrl = this.url
  }
}
